import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { Spinner } from '@zapier/design-system';
import { clsx } from 'clsx';
import React from 'react';
import { Button as Button$1 } from 'react-aria-components';

const button = "_button_3i2l4_9";
const spinnerWrapper = "_spinner-wrapper_3i2l4_52";
const fadeIn = "_fade-in_3i2l4_1";
const content = "_content_3i2l4_56";
const styles = {
	button: button,
	spinnerWrapper: spinnerWrapper,
	fadeIn: fadeIn,
	content: content
};

const Button = (_a) => {
  var { children, className, iconEnd, iconStart, id, isDisabled = false, isLoading = false, onPress, onPressEnd, onPressStart, size = "medium", style, type = "button", variant = "primary", "aria-label": ariaLabel } = _a, props = __rest(_a, ["children", "className", "iconEnd", "iconStart", "id", "isDisabled", "isLoading", "onPress", "onPressEnd", "onPressStart", "size", "style", "type", "variant", "aria-label"]);
  return React.createElement(
    Button$1,
    Object.assign({}, props, { "aria-busy": isLoading, "aria-label": isLoading ? "pending" : ariaLabel, "aria-live": isLoading ? "polite" : void 0, className: clsx(className, styles.button), "data-a11y-ignore": variant === "brand" ? "color-contrast" : void 0, "data-has-icon-end": iconEnd ? true : void 0, "data-has-icon-start": iconStart ? true : void 0, "data-loading": isLoading, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled: isDisabled || isLoading, onPress, onPressEnd, onPressStart, style, type }),
    isLoading && React.createElement(
      "div",
      { className: styles.spinnerWrapper },
      React.createElement(Spinner, null)
    ),
    React.createElement(
      "div",
      { className: styles.content },
      iconStart,
      children,
      iconEnd
    )
  );
};

export { Button };
//# sourceMappingURL=Button.es.js.map
